var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"role":"region","aria-live":"polite"}},[(_vm.isShowMoreMsg)?_c('div',{staticClass:"more-message"},[_vm._v(_vm._s(_vm.$t('moreMessage')))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }